export const TokenType = {
    Ibc: 'ibc',
    Cw20: 'cw20',
    Spl: 'spl',
    Erc20: 'erc20',
    Lp: 'lp',
    Evm: 'evm',
    Native: 'native',
    Symbol: 'symbol',
    TokenFactory: 'tokenFactory',
    InsuranceFund: 'insuranceFund',
    Unknown: 'unknown',
};
export const TokenVerification = {
    Verified: 'verified',
    Submitted: 'submitted',
    Internal: 'internal',
    External: 'external',
    Unverified: 'unverified',
};
export const TokenSource = {
    Aptos: 'aptos',
    Solana: 'solana',
    Cosmos: 'cosmos',
    Ethereum: 'ethereum',
    EthereumWh: 'ethereum-wormhole',
    Polygon: 'polygon',
    Klaytn: 'klaytn',
    Arbitrum: 'arbitrum',
    Sui: 'sui',
    Ibc: 'ibc',
    BinanceSmartChain: 'binance-smart-chain',
    Axelar: 'axelar',
};
